
import React, { useEffect, useState } from 'react'
import './ContactMe.css'

function ContactMe() {
  // FORM CONTROLLERS 
  const [emailVal, setEmailVal] = useState("");
  const [passVal, setPassVal] = useState("");
  const [phoneVal, setPhoneVal] = useState("");
  const [extraSVal, setExtraSVal] = useState("");
  const [headingBk, setHeadingBk] = useState(null);
  
  useEffect(() => {
    document.title = "LeeBakes - Contact Me"
  })
  let userFormData = new Object();
  const PostData = () => {
    
    userFormData.userEmail = emailVal;
    userFormData.userPassword = passVal;
    userFormData.userPhoneNumber = phoneVal;
    userFormData.ExtraSpaceData = extraSVal;
    console.log(userFormData)
    setEmailVal("");
    setPassVal("");
    setPhoneVal("");
    setExtraSVal("")
    setHeadingBk("Data Object Created. You Can Check Console.")
  }
  
  return (
    <>
      <div className="whole-div">
        <div className="container-fluid">
          <div className='text-center d-flex justify-content-center align-items-center my-3' data-aos ="fade-down">
            <h1 className='setWid fs-1'>You can directly contact me by filling the form below.</h1>

          </div>
          <div className="container fluid d-flex justify-content-center align-items-center" data-aos='fade-up'>
            <div className="whole-form-div">
              <div className="mb-3">
                <label htmlFor="exampleFormControlInput1" className="form-label">Email address</label>
                <input type="email" className="form-control" id="exampleFormControlInput1" placeholder="name@example.com" required value={emailVal} onChange={(event) => { setEmailVal(event.target.value) }} />
              </div>
              <div className="mb-3">
                <label htmlFor="exampleFormControlInput1" className="form-label">Password</label>
                <input type="password" className="form-control" id="exampleFormControlInput1" placeholder='Enter Password Here' required value={passVal} onChange={(event) => { setPassVal(event.target.value) }} />
              </div>
              <div className="mb-3">
                <label htmlFor="exampleFormControlInput1" className="form-label">Phone Number</label>
                <input type="number" className="form-control" id="exampleFormControlInput1" placeholder='Enter Phone Number Here' required value={phoneVal} onChange={(event) => { setPhoneVal(event.target.value) }} />
              </div>
              <div className="mb-3">
                <label htmlFor="exampleFormControlTextarea1" className="form-label">Extra Writing Space   (Optional)</label>
                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" placeholder='Example : I really liked your brownies!' value={extraSVal} onChange={(event) => { setExtraSVal(event.target.value) }}></textarea>
                <button className='btn btn-outline-primary my-4' onClick={PostData}>Submit</button>
              </div>
            </div>
          </div>
          {/* SHOWING OBJECT DATA  */}
         <div className='d-flex justify-content-center align-items-center flex-column text-center'>
         <h1 className='fs-4'>{headingBk}</h1>
         </div>
        </div>
      </div>

    </>
  )
}

export default ContactMe